module.exports = __webpack_public_path__ + "media/images/icons/elegi-d618ff1e2e5a779f15da28dcfb4db9af.svg";